function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

/**
 * Prevent page scroll when a modal is visible on mobile devices
 */
function preventDefault(e) {
  e.preventDefault();
}

let scrollY; // we'll store the scroll position here

/**
 *
 * @param {*} modal Object. Preferably an element with an ID
 * @returns
 */
function showModal(modal) {
  if (!modal) return;

  // don't apply the prevent-scroll for filters on larger screens
  if (modal.id === 'CollectionFiltersForm' && window.innerWidth >= 768) return;

  // remember scroll position
  scrollY = window.scrollY;

  // USING FIXED POSITION TO PREVENT SCROLLING WAS BREAKING PARTS OF THE PDP PAGE
  // prevent the body from jumping when the position fixed is added and wait to make sure it's been added
  document.documentElement.classList.add('prevent-scroll');

  // old method
  // REMOVING THIS HACK BROKE THE HEADER AND LIKELY OTHER AREAS
  //  document.body.style.top = `${
  //   scrollY < window.innerHeight ? 0 - scrollY : 0
  // }px`;
  // setTimeout(() => {
  //   document.documentElement.classList.add("prevent-scroll");
  // }, 100);

  modal.addEventListener('pointermove', preventDefault);
}

/**
 *
 * @param {*} modal Object. Should be the same as passed above
 * @returns
 */
function hideModal(modal) {
  if (!modal) return;

  modal.removeEventListener('pointermove', preventDefault);
  document.documentElement.classList.remove('prevent-scroll');
  document.body.style.top = 0;
  // restore scroll position
  window.scrollTo(0, scrollY);
}

const debug = () => {
  return window.location.hostname === '127.0.0.1' || window.location.hostname.indexOf('myshopify.com') !== -1;
};

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event?.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

function getNodeIndex(node) {
  return Array.from(node.parentNode.children).indexOf(node);
}

// back to top button
document.querySelectorAll('[data-back-to-top]').forEach(($button) => {
  $button.addEventListener('click', (e) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: 'smooth' });
  });
});

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt2 = document.createElement('option');
        opt2.value = provinces[i][0];
        opt2.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt2);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/**
 * unescapeHTML
 * @description Un-escapes an escaped HTML string.
 * @param {String} str an escaped html string
 * @returns {String} an un-escaped html string
 */
function unescapeHTML(str) {
  return str.replace(
    /&amp;|&lt;|&gt;|&#39;|&quot;/g,
    (tag) =>
      ({
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&#39;': "'",
        '&quot;': '"',
      })[tag] || tag,
  );
}

// remove the cookie popup when developing because it doesn't work and leaves an overlay blocking the page
if (debug()) {
  setTimeout(() => {
    document.getElementById('onetrust-consent-sdk')?.remove();
  }, 3000);
}

/**
 * Fetch additional product data
 * @description Fetches additional product data from an alternate product view (or from session storage if already fetched).
 * @param {String} productHandle
 * @returns {Object}
 */
async function fetchAdditionalProductData(productHandle) {
  const storageKey = 'additional-product-data';
  const stored = sessionStorage.getItem(storageKey);
  const storedData = stored ? JSON.parse(stored) : null;

  if (storedData && storedData[productHandle]) {
    return storedData[productHandle];
  }

  const url = `/products/${productHandle}?view=product-data`;

  try {
    const response = await fetch(url);

    if (response.status !== 200) throw new Error(response.status);

    const result = await response.text();

    const resultsMarkup = new DOMParser().parseFromString(result, 'text/html').querySelector('[data-product-data]').innerHTML;
    const productData = JSON.parse(resultsMarkup);

    sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        ...storedData,
        [productHandle]: productData,
      }),
    );

    return productData;
  } catch (error) {
    console.error('Error fetching alternate product template ?view=product-data:', error);
    return;
  }
}

/**
 * Image settings and functions
 */
const imageSettings = {
  image_size: '310x403',
  image_breakpoints: ['360', '480', '768', '1024', '1200', '1440'],
  image_sizes: ['154x200', '220x286', '360x468', '290x377', '340x442', '310x403'],
};

function responsiveImage(alt, image, addSettings) {
  const settings = {
    alt: alt,
    image: image,
    imageSize: '304x395',
    imageBreakpoints: ['360', '480', '768', '1024', '1200', '1440'],
    imageSizes: ['150x195', '210x273', '354x460', '288x374', '249x324', '304x395'],
    ...addSettings,
  };

  // Return fallback image if no image found
  if (!settings.image) {
    return `
      <picture>
        <img loading="lazy" alt="${settings.alt}" width="304" height="395" src="http://cdn.shopify.com/s/images/admin/no-image-compact.gif">
      </picture>
    `;
  }

  // Build image
  const imageHtml = `
    <img
      loading="lazy"
      alt="${settings.alt}"
      width="${settings.imageSize.split('x')[0]}"
      height="${settings.imageSize.split('x')[1]}"
      src="${settings.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + settings.imageSize + '_crop_center.$2')}"
      srcset="${settings.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + settings.imageSize + '_crop_center.$2')} 1x, ${settings.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + settings.imageSize + '_crop_center@2x.$2')} 2x"
    >
  `;

  // Build sources
  const sources = settings.imageSizes
    .map((size, index) => {
      return `
      <source
        media="(max-width: ${settings.imageBreakpoints[index]}px)"
        srcset="${settings.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '_crop_center.$2')} 1x,
        ${settings.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '_crop_center@2x.$2')} 2x"
      >
    `;
    })
    .join('');

  return `
    <picture>
      ${sources}
      ${imageHtml}
    </picture>
  `;
}

/**
 * Helps for product card DOM changes
 */
const formatMoney = (cents) => {
  let priceInCents = cents;

  /**
   * Uncomment the following block to support Shopify multi currency
   * and convert prices from store currency to the currency selected by
   * the user (aka "presentment" currency).
   * Please note that this relies on the `Shopify.currency` object exposed
   * by Shopify which is an undocumented feature and can change at any time.
   */
  if (typeof Shopify !== 'undefined' && typeof Shopify.currency !== 'undefined' && typeof Shopify.currency.rate !== 'undefined' && typeof Shopify.currency.active !== 'undefined') {
    // Convert to "presentment" currency using the rate provided by Shopify
    priceInCents = priceInCents * Shopify.currency.rate;
    // Round up to the nearest whole number keeping in accordance with
    // the default rounding strategy of Shopify
    priceInCents = Math.ceil(priceInCents);

    /**
     * Shopify uses different rounding strategies for different currencies.
     * The logic below might need to be customised based on the active currencies.
     * Note: Please only include currencies other than your store currency.
     */
    var storeCurrency = document.body.dataset.storeCurrency;

    if (Shopify.currency.active !== storeCurrency) {
      // Round up to the 95th cent for EUR
      if (Shopify.currency.active === 'EUR') {
        //priceInCents = parseInt(priceInCents / 100, 10) * 100 + 95;

        // Actually round up to the 00th cent
        priceInCents = parseInt(priceInCents / 100, 10) * 100 + 100;
      }
      // Round up to the 00th cent for GBP, USD, DKK
      else if (Shopify.currency.active === 'AUD' || Shopify.currency.active === 'CAD' || Shopify.currency.active === 'HKD' || Shopify.currency.active === 'JPY' || Shopify.currency.active === 'NZD' || Shopify.currency.active === 'SAR' || Shopify.currency.active === 'SGD' || Shopify.currency.active === 'SEK' || Shopify.currency.active === 'CHF' || Shopify.currency.active === 'AED' || Shopify.currency.active === 'USD') {
        priceInCents = parseInt(priceInCents / 100, 10) * 100 + 100;
      }
    }
  }

  var val = (priceInCents / 100.0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  var format = window.settings.moneyFormat || '£{{amount}}';

  // Not necessary, but allows for more risk tolerance if Shopify.formatMoney doesn't work as we want
  var regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
  if (format.match(regexp)) {
    return format.replace(regexp, '$1' + val + '$2');
  }

  regexp = /^([^{}]*)\{\{amount_with_comma_separator\}\}([^{}]*)$/;
  if (format.match(regexp)) {
    var money = val.replace(/[.]/, '|');
    money = money.replace(/[,]/, '.');
    money = money.replace(/[|]/, ',');
    return format.replace(regexp, '$1' + money + '$2');
  }

  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(priceInCents, format);
  }

  return '$' + val;
};

formatPrice = (value) => formatMoney(Number(value) * 100);

formatPriceWithComparison = (price, compareAtPrice) => {
  const comparing = Number(compareAtPrice) && Number(compareAtPrice) > Number(price);
  let res = `
    <span class="${comparing ? 'text-red' : 'text-primary'}">
      ${formatPrice(price)}
    </span>
  `;

  if (comparing) {
    res += ` <span class="text-gray"><s>${formatPrice(compareAtPrice)}</s></span>`;
  }

  return res;
};

/**
 * Handle card DOM changes
 * @description Handles product card DOM changes after hover or color click events.
 * @param {HTMLElement} card the product card html element
 * @param {Object} additionalProductData additional product data gotten from a fetch or storage
 */
async function productCardDomChange(card, additionalProductData) {
  const cardHandle = card.dataset.handle;
  const { handle, title, vendor, imgUrl, imgAlternateUrl, badges, price, compareAtPrice, variation_title } = additionalProductData;
  const imgSecondaryElem = card.querySelector('[data-product-card-image-secondary]');

  imgSecondaryElem.innerHTML = responsiveImage(title, imgAlternateUrl, imageSettings);

  // No need to continue if we're hovering on the initial card
  if (cardHandle === handle) return;

  // Change card handle
  card.dataset.handle = handle;

  // Change primary image
  const imgPrimaryElem = card.querySelector('[data-product-card-image-primary]');
  imgPrimaryElem.innerHTML = responsiveImage(title, imgUrl, imageSettings);

  // Change badges
  const badgesElem = card.querySelector('[data-product-card-badges]');
  badgesElem.innerHTML = unescapeHTML(badges);

  // Change vendor
  const vendorElem = card.querySelector('[data-product-card-vendor]');
  if (variation_title && variation_title !== '') {
    vendorElem.innerHTML = `<span>${vendor}</span> • <span class="weight-regular">${variation_title}</span>`;
  } else {
    vendorElem.innerHTML = `<span>${vendor}</span>`;
  }

  // Change title
  const titleElem = card.querySelector('[data-product-card-title]');
  titleElem.innerHTML = `<span>${title}</span>`;

  // Change price
  const priceElem = card.querySelector('[data-product-card-price]');
  priceElem.innerHTML = `
    <span>
      ${formatPriceWithComparison(price, compareAtPrice)}
    </span>
  `;

  // Change product page urls
  card.querySelectorAll('[data-product-card-link]').forEach((anchor) => {
    anchor.href = `/products/${handle}`;
  });
}
